import { createFileRoute } from '@tanstack/react-router'
import { Scoring } from '@/features/scoring'

export const Route = createFileRoute('/_authenticated/scoring/')({
  component: Scoring,
})
